import { OrderLine } from 'src/graphql/types/delivery';
import { sortOrderLines } from 'src/utils/orderLineSorting';
import { ThemeUICSSObject } from 'theme-ui';
import Divider, { DividerTypes } from './Divider';
import OrderLineInfo from './OrderLineInfo';

export type SortedOrderLineListProps = {
  orderId: string;
  orderLines: OrderLine[];
  itemLevelTraking?: boolean;
  isStopVisited?: boolean;
  isFulfilled?: boolean;
  stopId: string;
  editable?: boolean;
  searchValue?: string;
  showDividers?: boolean;
  dividerColor?: string;
  dividerStyle?: ThemeUICSSObject;
};

export const SortedOrderLineList = ({
  orderLines,
  itemLevelTraking = false,
  isStopVisited = false,
  isFulfilled = true,
  stopId,
  orderId,
  editable = true,
  searchValue,
  showDividers = true,
  dividerColor,
  dividerStyle = { marginTop: '16px', marginBottom: '16px' },
}: SortedOrderLineListProps): JSX.Element => {
  const sortedOrderLines = sortOrderLines(orderLines);

  return (
    <>
      {sortedOrderLines.map((orderLine, orderLineIndex) => (
        <div key={orderLine.id}>
          <OrderLineInfo
            itemLevelTraking={itemLevelTraking}
            isStopVisited={isStopVisited}
            orderLine={orderLine}
            isFulfilled={isFulfilled}
            stopId={stopId}
            orderId={orderId}
            editable={editable}
            searchValue={searchValue}
          />
          {showDividers && orderLineIndex < sortedOrderLines.length - 1 && (
            <Divider
              type={DividerTypes.dash}
              color={dividerColor}
              style={dividerStyle}
            />
          )}
        </div>
      ))}
    </>
  );
};

export default SortedOrderLineList;
